import geojsonRegions from '../data/regions-metropole'
import geojsonMartinique from '../data/martinique'
import geojsonReunion from '../data/reunion'
import geojsonGuadeloupe from '../data/guadeloupe'
import geojsonDeptRegion11 from '../data/departements-11'
import geojsonDeptRegion24 from '../data/departements-24'
import geojsonDeptRegion27 from '../data/departements-27'
import geojsonDeptRegion28 from '../data/departements-28'
import geojsonDeptRegion32 from '../data/departements-32'
import geojsonDeptRegion44 from '../data/departements-44'
import geojsonDeptRegion52 from '../data/departements-52'
import geojsonDeptRegion53 from '../data/departements-53'
import geojsonDeptRegion75 from '../data/departements-75'
import geojsonDeptRegion76 from '../data/departements-76'
import geojsonDeptRegion84 from '../data/departements-84'
import geojsonDeptRegion93 from '../data/departements-93'
import geojsonDeptRegion94 from '../data/departements-94'
import geojsonDeptRegion01 from '../data/departements-01'
import geojsonDeptRegion02 from '../data/departements-02'
import geojsonDeptRegion04 from '../data/departements-04'

export var regionFrance = {
    customClassName: "france-metropolitaine-map",
    id: "france-metropolitaine-map",
    zoom: 10,
    center: [46.85, 2.3518],
    enableControls: false,
    geoJson: geojsonRegions,
    fitGeoJsonBounds: true
}

export var guadeloupe = {
    customClassName: "france-reunion-map",
    id: "france-reunion-map",
    zoom: 10,
    center: [46.85, 2.3518],
    enableControls: false,
    geoJson: geojsonGuadeloupe,
    fitGeoJsonBounds: true
}

export var martinique = {
    customClassName: "france-martinique-map",
    id: "france-martinique-map",
    zoom: 10,
    center: [46.85, 2.3518],
    enableControls: false,
    geoJson: geojsonMartinique,
    fitGeoJsonBounds: true
}

export var reunion = {
    customClassName: "france-reunion-map",
    id: "france-reunion-map",
    zoom: 10,
    center: [46.85, 2.3518],
    enableControls: false,
    geoJson: geojsonReunion,
    fitGeoJsonBounds: true
}

const regionLabelToCode = {
    "Île-de-France": "11",
    "Centre-Val de Loire": "24",
    "Bourgogne-Franche-Comté": "27",
    "Normandie": "28",
    "Hauts-de-France": "32",
    "Grand Est": "44",
    "Pays de la Loire": "52",
    "Bretagne": "53",
    "Nouvelle-Aquitaine": "75",
    "Occitanie": "76",
    "Auvergne-Rhône-Alpes": "84",
    "Provence-Alpes-Côte d'Azur": "93",
    "Corse": "94",
    "Guadeloupe": "01",
    "Martinique": "02",
    "La Réunion": "04"
};

const regionCodeToLabel = {
    "11": "Île-de-France",
    "24": "Centre-Val de Loire",
    "27": "Bourgogne-Franche-Comté",
    "28": "Normandie",
    "32": "Hauts-de-France",
    "44": "Grand Est",
    "52": "Pays de la Loire",
    "53": "Bretagne",
    "75": "Nouvelle-Aquitaine",
    "76": "Occitanie",
    "84": "Auvergne-Rhône-Alpes",
    "93": "Provence-Alpes-Côte d'Azur",
    "94": "Corse",
    "01": "Guadeloupe",
    "02": "Martinique",
    "04": "La Réunion"
};

const regionToDepartements = {
    "11": geojsonDeptRegion11,
    "24": geojsonDeptRegion24,
    "27": geojsonDeptRegion27,
    "28": geojsonDeptRegion28,
    "32": geojsonDeptRegion32,
    "44": geojsonDeptRegion44,
    "52": geojsonDeptRegion52,
    "53": geojsonDeptRegion53,
    "75": geojsonDeptRegion75,
    "76": geojsonDeptRegion76,
    "84": geojsonDeptRegion84,
    "93": geojsonDeptRegion93,
    "94": geojsonDeptRegion94,
    "01": geojsonDeptRegion01,
    "02": geojsonDeptRegion02,
    "04": geojsonDeptRegion04
};

export function departementsRegion(idRegion) {
    return regionToDepartements[idRegion] || '{"type": "FeatureCollection", "features": []}';
}

export function getRegionLabel(idRegion) {
    return regionCodeToLabel[idRegion];
}
